module.exports = __webpack_public_path__ + "img/warning-yellow.9514b559.svg";